import LSClassDetailEditSurvey from './LSClassDetailEditSurvey'

export default LSClassDetailEditSurvey
